import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, errorText, fileUrl } from "@/lib/api";
import { PageTitle } from "@/admin/AdminLayout";

export default function ArtworksAdmin() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ title: "", place: "", year: "" });
  const [adding, setAdding] = useState(false);
  const refresh = () => api.get("/admin/artworks").then((r) => setList(r.data));
  useEffect(() => { refresh(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/artworks", form); setForm({ title: "", place: "", year: "" }); setAdding(false); toast.success("Artwork added"); refresh(); }
    catch (err) { toast.error(errorText(err)); }
  };
  const remove = async (a) => {
    if (!window.confirm(`Delete "${a.title}"? It will be removed from all exhibitions.`)) return;
    try { await api.delete(`/admin/artworks/${a.id}`); toast.success("Deleted"); refresh(); } catch (err) { toast.error(errorText(err)); }
  };

  return (
    <div data-testid="admin-artworks-page">
      <PageTitle action={<button type="button" onClick={() => setAdding(!adding)} className="btn-accent px-4 py-2 text-xs flex items-center gap-2" data-testid="artwork-add-toggle"><Plus size={14} /> Add artwork</button>}>Artworks <span className="text-[var(--muted)] text-xl">({list.length})</span></PageTitle>
      {adding && (
        <form onSubmit={add} className="grid sm:grid-cols-[2fr_1fr_1fr_auto] gap-3 mb-8 border border-[var(--line)] p-4 items-end" data-testid="artwork-add-form">
          <div><label className="label" htmlFor="new-title">Title</label><input id="new-title" className="field" placeholder="e.g. Girl with Balloon" required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="artwork-add-title" /></div>
          <div><label className="label" htmlFor="new-place">Place</label><input id="new-place" className="field" placeholder="e.g. London" value={form.place} onChange={(e) => setForm({ ...form, place: e.target.value })} data-testid="artwork-add-place" /></div>
          <div><label className="label" htmlFor="new-year">Year</label><input id="new-year" className="field" placeholder="e.g. 2002" value={form.year} onChange={(e) => setForm({ ...form, year: e.target.value })} data-testid="artwork-add-year" /></div>
          <button type="submit" className="btn-accent px-5 py-3 text-xs" data-testid="artwork-add-submit">Create</button>
        </form>
      )}
      <table className="w-full admin-table text-sm" data-testid="artwork-table">
        <thead><tr><th></th><th>Title</th><th className="hidden sm:table-cell">Place · Year</th><th>Languages</th><th></th></tr></thead>
        <tbody>
          {list.map((a) => (
            <tr key={a.id} data-testid={`artwork-row-${a.id}`}>
              <td className="w-14"><div className="w-12 h-12 overflow-hidden">{a.image_url ? <img src={fileUrl(a.image_url)} alt="" className="w-full h-full object-cover" /> : <div className="art-placeholder w-full h-full text-[0.5rem]">img</div>}</div></td>
              <td><Link to={`/admin/artworks/${a.id}`} className="font-semibold hover:text-accent transition-colors" data-testid={`artwork-edit-link-${a.id}`}>{a.title}</Link></td>
              <td className="hidden sm:table-cell text-[var(--muted)]">{a.place} · {a.year}</td>
              <td className="text-xs text-[var(--muted)]">{Object.entries(a.content || {}).map(([k, c]) => <span key={k} className={`inline-block mr-2 ${c.audio_url && c.text ? "text-white" : ""}`}>{k.toUpperCase()}</span>)}</td>
              <td className="text-right"><button type="button" onClick={() => remove(a)} className="ctrl !w-9 !h-9 text-[var(--muted)] hover:text-accent" aria-label="Delete" data-testid={`artwork-delete-${a.id}`}><Trash2 size={16} /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
